import { render } from "./CriticalEngagements.vue?vue&type=template&id=1b583beb"
import script from "./CriticalEngagements.vue?vue&type=script&lang=js"
export * from "./CriticalEngagements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__